// Defines main application routes

//General
import { routes } from './routes';
import Default from '../pages/general/dashboard/Default';

//Applications
// import ProjectList from "../pages/applications/project/ProjectList";
// import CreateProject from "../pages/applications/project/CreateProject";
// import FileManager from "../pages/applications/FileManager";
// import AddProduct from "../pages/applications/eCommerce/AddProduct";
// import Product from "../pages/applications/eCommerce/Product";
// import ProductPage from "../pages/applications/eCommerce/ProductPage";
// import ProductList from "../pages/applications/eCommerce/ProductList";
// import PaymentDetails from "../pages/applications/eCommerce/PaymentDetails";
// import OrderHistory from "../pages/applications/eCommerce/OrderHistory";
// import Invoice1 from "../pages/applications/eCommerce/invoice/Invoice1";
// import Invoice2 from "../pages/applications/eCommerce/invoice/Invoice2";
// import Invoice3 from "../pages/applications/eCommerce/invoice/Invoice3";
// import Invoice4 from "../pages/applications/eCommerce/invoice/Invoice4";
// import Invoice5 from "../pages/applications/eCommerce/invoice/Invoice5";
// import Invoice6 from "../pages/applications/eCommerce/invoice/Invoice6";
// import Cart from "../pages/applications/eCommerce/Cart";
// import WishList from "../pages/applications/eCommerce/WishList";
// import Checkout from "../pages/applications/eCommerce/Checkout";
// import Pricing from "../pages/applications/eCommerce/Pricing";
// import SocialApp from "../pages/applications/SocialApp";
// import LetterBox from "../pages/applications/LetterBox";
// import Contacts from "../pages/applications/Contacts";
// import Tasks from "../pages/applications/Tasks";
import UsersProfile from '../pages/applications/users/UsersProfile';
import EditProfile from '../pages/applications/users/EditProfile';
import UsersCard from '../pages/applications/users/UsersCard';
// import PrivateChat from "../pages/applications/chat/Private";
// import GroupChat from "../pages/applications/chat/Group";
// import Bookmarks from "../pages/applications/Bookmarks";
// import Calendar from "../pages/applications/Calendar";
// import SearchResult from "../pages/applications/SearchResult";
// import ToDo from "../pages/applications/ToDo";

// //Forms & Tables
// import FormValidation from "../pages/formsAndTable/forms/formControls/FormValidation";
// import CheckBoxAndRadio from "../pages/formsAndTable/forms/formControls/CheckboxAndRadio";
// import InputMark from "../pages/formsAndTable/forms/formControls/InputMark";
// import MegaOptions from "../pages/formsAndTable/forms/formControls/MegaOptions";
// import BaseInput from "../pages/formsAndTable/forms/formControls/BaseInput";
// import InputGroup from "../pages/formsAndTable/forms/formControls/InputGroup";
// import DatePicker from "../pages/formsAndTable/forms/formWidgets/DatePicker";
// import TouchSpin from "../pages/formsAndTable/forms/formWidgets/TouchSpin";
// import Switch from "../pages/formsAndTable/forms/formWidgets/Switch";
// import TypeAhead from "../pages/formsAndTable/forms/formWidgets/TypeAhead";
// import Clipboard from "../pages/formsAndTable/forms/formWidgets/Clipboard";
// import FormWizard1 from "../pages/formsAndTable/forms/formLayout/FormWizard1";
// import FormWizard2 from "../pages/formsAndTable/forms/formLayout/FormWizard2";

// import BasicTables from "../pages/formsAndTable/tables/reactstrapTables/BasicTables";
// import TableComponents from "../pages/formsAndTable/tables/reactstrapTables/TableComponents";
// import BasicInit from "../pages/formsAndTable/tables/dataTables/BasicInit";
// import AdvanceInit from "../pages/formsAndTable/tables/dataTables/AdvanceInit";
// import Api from "../pages/formsAndTable/tables/dataTables/Api";
// import DataSources from "../pages/formsAndTable/tables/dataTables/DataSources";

// //Components
// import Typography from "../pages/uiKits/Typography";
// import Tabs from "../pages/uiKits/Tabs";
// import Lists from "../pages/uiKits/Lists";
// import HelperClasses from "../pages/uiKits/HelperClasses";
// import Grid from "../pages/uiKits/Grid";
// import Avatars from "../pages/uiKits/Avatars";
// import Modal from "../pages/uiKits/Modal";
// import Popover from "../pages/uiKits/Popover";
// import TagAndPills from "../pages/uiKits/TagAndPills";
// import ProgressBar from "../pages/uiKits/ProgressBar";
// import Alert from "../pages/uiKits/Alert";
// import Tooltip from "../pages/uiKits/Tooltip";
// import Dropdown from "../pages/uiKits/Dropdown";
// import Accordion from "../pages/uiKits/Accordion";
// import Scrollable from "../pages/bonusUi/Scrollable";
// import ImageCropper from "../pages/bonusUi/ImageCropper";
// import BasicCard from "../pages/bonusUi/BasicCard";
// import CreativeCard from "../pages/bonusUi/CreativeCard";
// import Carousel from "../pages/bonusUi/Carousel";
// import Ribbons from "../pages/bonusUi/Ribbons";
// import Pagination from "../pages/bonusUi/Pagination";
// import Breadcrumb from "../pages/bonusUi/Breadcrumb";
// import RangeSlider from "../pages/bonusUi/RangeSlider";
// import Dropzone from "../pages/bonusUi/Dropzone";
// import Tour from "../pages/bonusUi/Tour";
// import SweetAlert from "../pages/bonusUi/SweetAlert";
// // import Tree from "../pages/bonusUi/Tree";
// import Toasts from "../pages/bonusUi/Toasts";
// import Rating from "../pages/bonusUi/Rating";
// import TimeLine from "../pages/bonusUi/TimeLine";
// import ApexChart from "../pages/charts/ApexChart";
// import GoogleChart from "../pages/charts/GoogleChart";
// import ChartJs from "../pages/charts/ChartJs";
// import FeatherIcon from "../pages/icon/FeatherIcon";
// import FontAwesome from "../pages/icon/FontAwesome";
// import IcoIcon from "../pages/icon/IcoIcon";
// import ThemifyIcon from "../pages/icon/ThemifyIcon";
// import FlagIcon from "../pages/icon/FlagIcon";
// import WhetherIcon from "../pages/icon/WhetherIcon";
// import DefaultStyle from "../pages/button/DefaultStyle";
// import ButtonGroup from "../pages/button/ButtonGroup";

// //Pages
// import SamplePage from "../pages/pages/SamplePage";

// //Miscellaneous
// import GalleryGrid from "../pages/miscellaneous/gallery/GalleryGrid";
// import Faq from "../pages/miscellaneous/Faq";
// import CkEditors from "../pages/miscellaneous/editors/CkEditor";
// import MdeEditor from "../pages/miscellaneous/editors/MdeEditor";
// import AceCodeEditor from "../pages/miscellaneous/editors/AceCodeEditor";

// import GalleryDescription from "../pages/miscellaneous/gallery/GalleryDescription";
// import MasonryGallery from "../pages/miscellaneous/gallery/MasonryGallery";
// import MasonryDescription from "../pages/miscellaneous/gallery/MasonryDescription";
// import GalleryHover from "../pages/miscellaneous/gallery/GalleryHover";
// import BlogSingle from "../pages/miscellaneous/blog/BlogSingle";
// import BlogDetails from "../pages/miscellaneous/blog/BlogDetails";
// import AddPost from "../pages/miscellaneous/blog/AddPost";
// import LearningList from "../pages/miscellaneous/learning/LearningList";
// // import CourseDetails from "../pages/miscellaneous/learning/CourseDetails";
// import GoogleMap from "../pages/miscellaneous/maps/GoogleMap";
// import LeafletMap from "../pages/miscellaneous/maps/LeafletMap";
// import CardsView from "../pages/miscellaneous/jobSearch/CardsView";
// import ListView from "../pages/miscellaneous/jobSearch/ListView";
// import JobDetails from "../pages/miscellaneous/jobSearch/JobDetails";
// import JobApply from "../pages/miscellaneous/jobSearch/JobApply";
// import SupportTicket from "../pages/miscellaneous/SupportTicket";

// //others
import Error400 from '../components/pages/others/errorPage/Error400';
import Error401 from '../components/pages/others/errorPage/Error401';
import Error403 from '../components/pages/others/errorPage/Error403';
import Error404 from '../components/pages/others/errorPage/Error404';
import Error500 from '../components/pages/others/errorPage/Error500';
import Error503 from '../components/pages/others/errorPage/Error503';
import LoginSimple from '../components/pages/others/authentication/LoginSimple';
import LoginWithBgImage from '../components/pages/others/authentication/LoginWithBgImage';
import LoginWithImageTwo from '../components/pages/others/authentication/LoginWithImageTwo';
import LoginWithValidation from '../components/pages/others/authentication/LoginWithValidation';
import LoginWithTooltip from '../components/pages/others/authentication/LoginWithTooltip';
import LoginSweetAlert from '../components/pages/others/authentication/LoginSweetAlert';
import RegisterSimple from '../components/pages/others/authentication/RegisterSimple';
import RegisterWithBgImage from '../components/pages/others/authentication/RegisterWithBgImage';
import RegisterWithImageTwo from '../components/pages/others/authentication/RegisterWithImageTwo';
import RegisterWizard from '../components/pages/others/authentication/registerWizard';
import UnlockUser from '../components/pages/others/authentication/UnlockUser';
import ForgetPassword from '../components/pages/others/authentication/ForgetPassword';
import ResetPassword from '../components/pages/others/authentication/ResetPassword';
import Maintenance from '../components/pages/others/authentication/Maintenance';
// import SimpleComingSoon from "../components/pages/others/comingSoon/SimpleComingSoon";
// import ComingWithBgImage from "../components/pages/others/comingSoon/ComingWithBgImage";
// import ComingWithBgVideo from "../components/pages/others/comingSoon/ComingWithBgVideo";
// import TwoFactor from "../pages/formsAndTable/forms/formLayout/TwoFactor";
// import KnowledgeBase from "../pages/miscellaneous/KnowledgeBase";
import CoursesList from '../pages/courses/CoursesList';
import LeaderBoard from '../pages/users/LeaderBoard';
import ExamList from '../pages/courses/ExamList';
import UploadCourses from '../pages/courses/UploadCourses';
import CourseDetails from '../pages/courses/CourseDetails';
import LessonDetails from '../pages/courses/LessonDetails';
import Users from '../pages/users/Users';
import Prompts from '../pages/openai/Prompts';
import StudentCoursesList from '../pages/courses/StudentCoursesList';
import StudentCourseDetails from '../components/courses/studentCoursesList/details/[id]';
import StudentLessonDetails from '../components/courses/studentCoursesList/lessonDetails';
import StudentExamCalendar from '../pages/courses/StudentExamCalendar';
import CreateCourse from '../pages/courses/CreateCourse';
import AssignToCourse from '../pages/courses/AssignToCourse';
import MeetBot from '../pages/meetBot/MeetBot';
import CreateAssistantExam from '../pages/assistant/CreateAssistantExam';
import path from 'path';
import BotTranscription from '../components/meetBot/[transcriptId]/BotTranscription';
import ExamDetailsPage from '../pages/exams/ExamDetailsPage';
import FeedBacksPage from '../pages/feedBacks/FeedBacksPage';
import DashboardPage from '../pages/dashboard/DashboardPage';
import UserStatPage from '../pages/dashboard/UserStatPage';
import UserDetailsStats from '../components/dashboard/userStats/[userId]/UserDetailsStats';
import LeadsListPage from '../pages/leads/LeadsListPage';
import LeadsDetailsPage from '../pages/leads/LeadsDetailsPage';
import Engagement from '../components/leads/engagement';
import Examinations from '../components/leads/examinations';
import CrmControlPage from '../pages/control/CrmControlPage';
import EngagementsDetails from '../components/leads/engagement/[id]';
import ScoringsPage from '../pages/scorings/ScoringsPage';
// import CRMExamDetails from '../components/leads/examinations/[id]';

export const AppRoutes = [
  //General
  { path: routes.Dashboard.Default, element: <DashboardPage /> },
  { path: routes.Dashboard.UserStats, element: <UserStatPage /> },
  { path: routes.Dashboard.UserDetailsStats, element: <UserDetailsStats /> },
  // { path: routes.Widgets.General, element: <General /> },
  // { path: routes.Widgets.Charts, element: <Chart /> },

  //Students
  { path: routes.Users.users, element: <Users /> },
  // { path: routes.Users.leaderBoard, element: <LeaderBoard /> },
  { path: routes.Users.Profile, element: <UsersProfile /> },
  { path: routes.Users.Edit, element: <EditProfile /> },
  { path: routes.Users.Cards, element: <UsersCard /> },
  { path: routes.Users.AssignToCourse, element: <AssignToCourse /> },

  //Courses
  // { path: routes.Courses.CreateCourse, element: <CreateCourse /> },
  { path: routes.Courses.CoursesList, element: <CoursesList /> },

  // { path: routes.Courses.ExamRequests, element: <ExamRequests /> },
  { path: routes.Courses.UploadCourses, element: <UploadCourses /> },
  {
    path: routes.Courses.CourseDetailsPage,
    element: <CourseDetails />,
  },
  {
    path: routes.Courses.LessonDetailsPage,
    element: <LessonDetails />,
  },
  {
    path: routes.Students.AllStudentCourses,
    element: <StudentCoursesList />,
  },
  {
    path: routes.Students.StudentCourseDetailsPage,
    element: <StudentCourseDetails />,
  },

  {
    path: routes.Students.StudentCourseLessonDetailsPage,
    element: <StudentLessonDetails />,
  },
  {
    path: routes.Students.StudentPrivateCourses,
    element: <StudentCoursesList />,
  },
  {
    path: routes.Students.MyCoursesCourseDetailsPage,
    element: <StudentCourseDetails />,
  },

  {
    path: routes.Students.MyCoursesCourseLessonDetailsPage,
    element: <StudentLessonDetails />,
  },
  {
    path: routes.Students.MyCoursesExamCalendar,
    element: <StudentExamCalendar />,
  },
  //OpenAI
  {
    path: routes.Openai.Prompts,
    element: <Prompts />,
  },
  //Exams
  { path: routes.Exams.ExamList, element: <ExamList /> },
  { path: routes.Exams.MeetBot, element: <MeetBot /> },
  { path: routes.Exams.MeetBotTranscription, element: <BotTranscription /> },
  { path: routes.Exams.CreateAssistantExam, element: <CreateAssistantExam /> },
  { path: routes.Exams.ExamDetails, element: <ExamDetailsPage /> },
  { path: routes.Exams.LeaderBoard, element: <LeaderBoard /> },

  //Feedbacks
  { path: routes.Feedbacks.FeedBacks, element: <FeedBacksPage /> },

  //Leads
  { path: routes.Leads.LeadsList, element: <LeadsListPage /> },
  { path: routes.Leads.LeadsDetails, element: <LeadsDetailsPage /> },
  { path: routes.Leads.Engagement, element: <Engagement /> },
  { path: routes.Leads.EngagementDetails, element: <EngagementsDetails /> },
  { path: routes.Leads.Examinations, element: <Examinations /> },

  //SCORINGS
  { path: routes.Scorings.scoringsAvg, element: <ScoringsPage /> },
  //CONTROL
  { path: routes.Control.Crm, element: <CrmControlPage /> },
  //  { path: routes.Leads.ExaminationsDetails, element: <CRMExamDetails /> },

  //Applications
  // { path: routes.Project.List, element: <ProjectList /> },
  // { path: routes.Project.Create, element: <CreateProject /> },
  // { path: routes.FileManager, element: <FileManager /> },
  // { path: routes.ECommerce.AddProduct, element: <AddProduct /> },
  // { path: routes.ECommerce.Product, element: <Product /> },
  // { path: routes.ECommerce.ProductPage, element: <ProductPage /> },
  // { path: routes.ECommerce.ProductList, element: <ProductList /> },
  // { path: routes.ECommerce.Payment, element: <PaymentDetails /> },
  // { path: routes.ECommerce.Orders, element: <OrderHistory /> },
  // { path: routes.ECommerce.Invoices.Invoice1, element: <Invoice1 /> },
  // { path: routes.ECommerce.Invoices.Invoice2, element: <Invoice2 /> },
  // { path: routes.ECommerce.Invoices.Invoice3, element: <Invoice3 /> },
  // { path: routes.ECommerce.Invoices.Invoice4, element: <Invoice4 /> },
  // { path: routes.ECommerce.Invoices.Invoice5, element: <Invoice5 /> },
  // { path: routes.ECommerce.Invoices.Invoice6, element: <Invoice6 /> },
  // { path: routes.ECommerce.Cart, element: <Cart /> },
  // { path: routes.ECommerce.Wishlist, element: <WishList /> },
  // { path: routes.ECommerce.Checkout, element: <Checkout /> },
  // { path: routes.ECommerce.Pricing, element: <Pricing /> },
  // { path: routes.Social, element: <SocialApp /> },
  // { path: routes.LetterBox, element: <LetterBox /> },
  // { path: routes.Contacts, element: <Contacts /> },
  // { path: routes.Tasks, element: <Tasks /> },
  // { path: routes.Users.Profile, element: <UsersProfile /> },
  // { path: routes.Users.Edit, element: <EditProfile /> },
  // { path: routes.Users.Cards, element: <UsersCard /> },
  // { path: routes.Chats.Private, element: <PrivateChat /> },
  // { path: routes.Chats.Group, element: <GroupChat /> },
  // { path: routes.Bookmarks, element: <Bookmarks /> },
  // { path: routes.Calendar, element: <Calendar /> },
  // { path: routes.Search, element: <SearchResult /> },
  // { path: routes.ToDo, element: <ToDo /> },

  //Forms & Tables
  // { path: routes.Forms.Controls.Validation, element: <FormValidation /> },
  // { path: routes.Forms.Controls.RadioCheckbox, element: <CheckBoxAndRadio /> },
  // { path: routes.Forms.Controls.InputMask, element: <InputMark /> },
  // { path: routes.Forms.Controls.MegaOptions, element: <MegaOptions /> },
  // { path: routes.Forms.Controls.BaseInput, element: <BaseInput /> },
  // { path: routes.Forms.Controls.InputGroup, element: <InputGroup /> },
  // { path: routes.Forms.Widgets.DatePicker, element: <DatePicker /> },
  // { path: routes.Forms.Widgets.TouchSpin, element: <TouchSpin /> },
  // { path: routes.Forms.Widgets.Switch, element: <Switch /> },
  // { path: routes.Forms.Widgets.TypeAhead, element: <TypeAhead /> },
  // { path: routes.Forms.Widgets.Clipboard, element: <Clipboard /> },
  // { path: routes.Forms.Layout.Wizard1, element: <FormWizard1 /> },
  // { path: routes.Forms.Layout.Wizard2, element: <FormWizard2 /> },
  // { path: routes.Forms.Layout.TwoFactor, element: <TwoFactor /> },
  // { path: routes.Tables.Reactstrap.Basic, element: <BasicTables /> },
  // { path: routes.Tables.Reactstrap.Components, element: <TableComponents /> },
  // { path: routes.Tables.Data.Basic, element: <BasicInit /> },
  // { path: routes.Tables.Data.Advanced, element: <AdvanceInit /> },
  // { path: routes.Tables.Data.API, element: <Api /> },
  // { path: routes.Tables.Data.Sources, element: <DataSources /> },

  // //Components
  // { path: routes.UiKits.Typography, element: <Typography /> },
  // { path: routes.UiKits.Tabs, element: <Tabs /> },
  // { path: routes.UiKits.Lists, element: <Lists /> },
  // { path: routes.UiKits.HelperClasses, element: <HelperClasses /> },
  // { path: routes.UiKits.Grid, element: <Grid /> },
  // { path: routes.UiKits.Avatars, element: <Avatars /> },
  // { path: routes.UiKits.Modal, element: <Modal /> },
  // { path: routes.UiKits.Popover, element: <Popover /> },
  // { path: routes.UiKits.TagPills, element: <TagAndPills /> },
  // { path: routes.UiKits.Progress, element: <ProgressBar /> },
  // { path: routes.UiKits.Alert, element: <Alert /> },
  // { path: routes.UiKits.Tooltip, element: <Tooltip /> },
  // { path: routes.UiKits.Dropdown, element: <Dropdown /> },
  // { path: routes.UiKits.Accordion, element: <Accordion /> },
  // { path: routes.BonusUi.Scrollable, element: <Scrollable /> },
  // { path: routes.BonusUi.ImageCropper, element: <ImageCropper /> },
  // { path: routes.BonusUi.BasicCard, element: <BasicCard /> },
  // { path: routes.BonusUi.CreativeCard, element: <CreativeCard /> },
  // { path: routes.BonusUi.Carousel, element: <Carousel /> },
  // { path: routes.BonusUi.Ribbons, element: <Ribbons /> },
  // { path: routes.BonusUi.Pagination, element: <Pagination /> },
  // { path: routes.BonusUi.Breadcrumb, element: <Breadcrumb /> },
  // { path: routes.BonusUi.RangeSlider, element: <RangeSlider /> },
  // { path: routes.BonusUi.Dropzone, element: <Dropzone /> },
  // { path: routes.BonusUi.Tour, element: <Tour /> },
  // { path: routes.BonusUi.SweetAlert2, element: <SweetAlert /> },
  // { path: routes.BonusUi.Tree, element: <Tree /> },
  //   { path: routes.BonusUi.Toasts, element: <Toasts /> },
  //   { path: routes.BonusUi.Rating, element: <Rating /> },
  //   { path: routes.BonusUi.Timeline, element: <TimeLine /> },
  //   { path: routes.Charts.Apex, element: <ApexChart /> },
  //   { path: routes.Charts.Google, element: <GoogleChart /> },
  //   { path: routes.Charts.ChartJs, element: <ChartJs /> },
  //   { path: routes.Icons.Feather, element: <FeatherIcon /> },
  //   { path: routes.Icons.FontAwesome, element: <FontAwesome /> },
  //   { path: routes.Icons.Ico, element: <IcoIcon /> },
  //   { path: routes.Icons.Themify, element: <ThemifyIcon /> },
  //   { path: routes.Icons.Flag, element: <FlagIcon /> },
  //   { path: routes.Icons.Whether, element: <WhetherIcon /> },
  //   { path: routes.Buttons.Default, element: <DefaultStyle /> },
  //   { path: routes.Buttons.Group, element: <ButtonGroup /> },

  //   //Pages
  //   { path: routes.Sample, element: <SamplePage /> },

  //   //Miscellaneous
  //   { path: routes.Gallery.Grid, element: <GalleryGrid /> },
  //   { path: routes.Faq, element: <Faq /> },
  //   { path: routes.Editors.CkEditor, element: <CkEditors /> },
  //   { path: routes.Editors.MdeEditor, element: <MdeEditor /> },
  //   { path: routes.Editors.ACECodeEditor, element: <AceCodeEditor /> },
  //   { path: routes.KnowLedgeBase, element: <KnowledgeBase /> },
  //   { path: routes.Gallery.GridDescription, element: <GalleryDescription /> },
  //   { path: routes.Gallery.Masonry, element: <MasonryGallery /> },
  //   { path: routes.Gallery.MasonryDescription, element: <MasonryDescription /> },
  //   { path: routes.Gallery.Hover, element: <GalleryHover /> },
  //   { path: routes.Blog.Single, element: <BlogSingle /> },
  //   { path: routes.Blog.Details, element: <BlogDetails /> },
  //   { path: routes.Blog.AddPost, element: <AddPost /> },
  //   { path: routes.Learning.List, element: <LearningList /> },
  //   // { path: routes.Learning.CourseDetails, element: <CourseDetails /> },
  //   { path: routes.Maps.Google, element: <GoogleMap /> },
  //   { path: routes.Maps.Leaflet, element: <LeafletMap /> },
  //   { path: routes.JobSearch.CardsView, element: <CardsView /> },
  //   { path: routes.JobSearch.ListView, element: <ListView /> },
  //   { path: routes.JobSearch.Details, element: <JobDetails /> },
  //   { path: routes.JobSearch.Apply, element: <JobApply /> },
  //   { path: routes.SupportTicket, element: <SupportTicket /> },
];

export const AuthRoutes = [
  // Error Pages
  { path: routes.ErrorPages.Error400, element: <Error400 /> },
  { path: routes.ErrorPages.Error401, element: <Error401 /> },
  { path: routes.ErrorPages.Error403, element: <Error403 /> },
  { path: routes.ErrorPages.Error404, element: <Error404 /> },
  { path: routes.ErrorPages.Error500, element: <Error500 /> },
  { path: routes.ErrorPages.Error503, element: <Error503 /> },
  //Authentication
  { path: routes.Auth.Login.Simple, element: <LoginSimple /> },
  { path: routes.Auth.Login.BgImage, element: <LoginWithBgImage /> },
  { path: routes.Auth.Login.BgTwoImage, element: <LoginWithImageTwo /> },
  { path: routes.Auth.Login.Validation, element: <LoginWithValidation /> },
  { path: routes.Auth.Login.Tooltip, element: <LoginWithTooltip /> },
  { path: routes.Auth.Login.SweetAlert, element: <LoginSweetAlert /> },
  { path: routes.Auth.Register.Simple, element: <RegisterSimple /> },
  { path: routes.Auth.Register.BgImage, element: <RegisterWithBgImage /> },
  { path: routes.Auth.Register.BgTwoImage, element: <RegisterWithImageTwo /> },
  { path: routes.Auth.Register.Wizard, element: <RegisterWizard /> },
  { path: routes.Auth.UnlockUser, element: <UnlockUser /> },
  { path: routes.Auth.Recovery.ForgetPassword, element: <ForgetPassword /> },
  { path: routes.Auth.Recovery.ResetPassword, element: <ResetPassword /> },
  { path: routes.Auth.Maintenance, element: <Maintenance /> },
  //Coming soon
  // { path: routes.ComingSoon.Simple, element: <SimpleComingSoon /> },
  // { path: routes.ComingSoon.Video, element: <ComingWithBgImage /> },
  // { path: routes.ComingSoon.Image, element: <ComingWithBgVideo /> },
];
